export const environment = {
  name: 'uat',
  production: false,
  pwa: true,
  appName: 'Learning Garden UAT',
  storageNamespace: 'learning-garden-uat'
} as const;
